export default __webpack_public_path__ + "static/news2-1-f0d1fcf0eb7baa7d48fbd5d2bbc41a58.jpg";